function replaceLocation(value) {
  if (value) {
    location.replace('/index.php?route=product/search&search=' + encodeURIComponent(value))
  }
}

function initSearchContainer(searchEl) {
  const searchInputEl = searchEl.querySelector('.js-search-input')
  const searchButtonEl = searchEl.querySelector('.js-search-button')
  const searchLabelEl = searchEl.querySelector('.js-search-label')

  searchButtonEl.addEventListener('click', () => {
    if (searchButtonEl.classList.contains('active')) {
      searchButtonEl.classList.remove('active')
      searchLabelEl.classList.remove('active')
    } else {
      searchButtonEl.classList.add('active')
      searchLabelEl.classList.add('active')
    }
  })

  searchInputEl.addEventListener('keyup', function(e) {
    if (e.keyCode === 13) {
      replaceLocation(searchInputEl.value)
    }
  })
}

export function initSearchContainers() {
  const searchEls = document.querySelectorAll('.js-search')

  searchEls.forEach(initSearchContainer)
}
